import { FC } from 'react';
import { Icons } from '~/assets/fonts/Icons/icons';
import Icon from '~/view/components/Controls/Icon/Icon';
import './style.scss';

const MarketplaceFeatureContact: FC = (): JSX.Element => {
  const openZohoChat = () => {
    if (typeof window.ZohoHCAsap?.Action === 'function') window.ZohoHCAsap.Action('open');
  };

  return (
    <div className="marketplace-feature-contact">
      <p className="family-medium text-size-20">Contact our support team</p>
      <button className="marketplace-feature-contact__btn" onClick={openZohoChat}>
        <div className="circle">
          <Icon name={Icons.Conversation} size={24} className="color-white" />
        </div>
        <div>
          <p className="family-regular text-size-14">We`re online</p>
          <p className="family-medium text-size-18 mt-1">Let`s chat</p>
        </div>
      </button>
    </div>
  );
};

export default MarketplaceFeatureContact;
